import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 md:py-16 px-4 md:px-8 max-w-4xl mx-auto" data-id="element-125">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="bg-gradient-to-br from-blush to-white rounded-xl md:rounded-2xl shadow-xl p-6 md:p-12 border-2 border-rose-gold" data-id="element-126">
        <div className="flex flex-col items-center text-center" data-id="element-127">
          <div className="w-14 h-14 md:w-20 md:h-20 bg-burgundy rounded-full flex items-center justify-center mb-4 md:mb-6" data-id="element-128">
            <ShieldCheckIcon className="w-8 h-8 md:w-12 md:h-12 text-white" data-id="element-129" />
          </div>

          <h2 className="font-playfair text-xl sm:text-2xl md:text-3xl font-bold text-burgundy mb-4 md:mb-6" data-id="element-130">
            La Garantie de 30 Jours
          </h2>

          <p className="text-sm sm:text-base md:text-lg text-gray-700 font-lato leading-relaxed" data-id="element-131">
            Essaie la méthode. Si tes fraises ne sont pas dignes d'une
            pâtisserie de luxe, ou si tu ne ressens pas cette immense fierté en
            offrant ta boîte,
            <span className="font-bold text-burgundy" data-id="element-132">
              {' '}
              je te rembourse chaque centime sur simple demande pendant 30 jours
            </span>
            . Sans aucune question.
          </p>
        </div>
      </motion.div>
    </section>;
}